export default __webpack_public_path__ + "static/media/login register-08.75e824e7.png";